export default {
  FORM_INPUT_PADDING: 7
};
